import React from "react";
import { Link } from "react-router-dom";
import Atention from "../../../assets/atention.JPG";
import "./styles.scss";

const CPFNotFound = () => {
  return (
    <div className="loginForm loginForgotPassword">
      <div className="cpfNotFound centralized-column">
        <h1 className="cpfNotFound__title centralized-column">
          <img src={Atention} alt="Atenção" />
          Atenção!
        </h1>
        <p>
          Não foram encontradas estas informações em nossa base de dados.
          <br />
          <br />
          Por gentileza, procure o Serviço de Atendimento ao Cliente para mais
          informações, no telefone: 00-0000-0000 ou no email:
          xxxxxx@xxxxxxxxxx.com.br
        </p>
        <div className="loginForgotPassword__toLogin">
          <Link className="loginForgotPassword__toLogin__link" to="/">
            [ RETORNAR AO LOGIN ]
          </Link>
        </div>
      </div>
    </div>
  );
};

export default CPFNotFound;
